"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterItemContentBucketFilter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_types_1 = require("@as-react/common-types");
const FilterSelectList_1 = require("./FilterSelectList");
const FilterItemContentBucketFilter = ({ desktop, filter, onFilterItemChange, }) => ((0, jsx_runtime_1.jsx)(FilterSelectList_1.FilterSelectList, { desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, type: common_types_1.BUCKET_FILTER }));
exports.FilterItemContentBucketFilter = FilterItemContentBucketFilter;
